import axios, { AxiosRequestConfig, AxiosResponse } from "axios"

const BASE_URL = process.env.REACT_APP_BASE_URL
const TIMEOUT = process.env.REACT_APP_API_TIMEOUT

const baseConfig = {
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  withCredentials: true,
}

export async function request(
  options: AxiosRequestConfig
): Promise<AxiosResponse> {
  const response = await axios({
    ...baseConfig,
    ...options,
  } as AxiosRequestConfig)
  return response.data
}
